/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_4_DescInputs */

const en_mk_feature_4_desc = /** @type {(inputs: Mk_Feature_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a model within your plan or connect your own AI service. Provider usage is billed separately.`)
};

const id_mk_feature_4_desc = /** @type {(inputs: Mk_Feature_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih model sesuai paket atau hubungkan layanan AI sendiri. Penggunaan penyedia tetap dihitung terpisah.`)
};

/**
* | output |
* | --- |
* | "Choose a model within your plan or connect your own AI service. Provider usage is billed separately." |
*
* @param {Mk_Feature_4_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_4_desc = /** @type {((inputs?: Mk_Feature_4_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_4_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_4_desc(inputs)
	return en_mk_feature_4_desc(inputs)
});